import {LibraryLaborDto, LibraryReadinessDto, LibraryReadinessState} from '../../../shared/dtos/comparable-library.dto';

export function formatPersonHours(labor: LibraryLaborDto): string {
  if (!labor.recorded) return 'Not recorded';
  const hours = labor.personMinutes / 60;
  return `${new Intl.NumberFormat(undefined, {maximumFractionDigits: 1}).format(hours)} person-hours`;
}

export function formatJobLength(seconds: number): string | null {
  if (seconds <= 0) return null;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.round((seconds % 3600) / 60);
  return hours > 0 ? `${hours} h ${minutes} min on site` : `${minutes} min on site`;
}

export function formatDate(value?: string | null): string {
  if (!value) return '';
  // Core stores UTC without a zone; say so to the parser.
  const date = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(value) ? value : `${value}Z`);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(undefined, {month: 'short', day: 'numeric', year: 'numeric'});
}

export const readinessLabel: Record<LibraryReadinessState, string> = {
  available: 'Available',
  preparing: 'Preparing',
  needs_attention: 'Needs attention',
};

const reasonText: Record<string, string> = {
  job_not_completed: 'the job is no longer completed',
  unsupported_operation_class: 'the operation type is not supported for comparisons',
  not_retrievable: 'it cannot be retrieved',
  deleted: 'the work item was deleted',
  tombstoned: 'the work item was deleted',
  ambiguous_work_order: 'the estimate has more than one job',
  company_mismatch: 'the job belongs to another company',
  not_approved: 'it is waiting for the library to catch up',
};

export function reasonLabel(reason: string): string {
  return reasonText[reason] ?? reason.replace(/_/g, ' ');
}

export function readinessSummary(readiness: LibraryReadinessDto): string {
  const parts: string[] = [];
  if (readiness.available) parts.push(`${readiness.available} available`);
  if (readiness.preparing) parts.push(`${readiness.preparing} preparing`);
  if (readiness.needsAttention) {
    const why = readiness.reasons.map(reasonLabel).join('; ');
    parts.push(`${readiness.needsAttention} need attention${why ? `: ${why}` : ''}`);
  }
  if (readiness.newToApprove) parts.push(`${readiness.newToApprove} new to approve`);
  return parts.join(' · ') || 'No approved work items';
}

export const operationLabel = (operationType: string) => operationType;

export const workItemTypeLabel: Record<string, string> = {
  Tree: 'Tree', TreeGroup: 'Tree group', FallenTree: 'Fallen tree', Stump: 'Stump', DebrisPile: 'Debris pile', Misc: 'Miscellaneous',
};
